const PropTypes = require('prop-types');
const React = require('react');
const AddressBox = require('./address_box.jsx');
const AddressForm = require('./address_form.jsx');
const classNames = require('classnames');
const DEFAULT_COUNTRY_CODE = 'US';

class EditableAddress extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editing: props.editing || false,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ editing: nextProps.editing });
  }

  radioInputId() {
    return `address-select-${this.props.addressId}`;
  }

  handleFormUpdate() {
    this.cancelEditing();
    this.props.handleUpdate();
  }

  radioInput() {
    if (this.props.selectable) {
      return (
        <input
          id={this.radioInputId()}
          type="radio"
          name="checkout[selected_shipping_address_id]"
          value={this.props.addressId}
          className="boxed-list__toggle"
          defaultChecked={this.props.selected}
          data-update-checkout-totals
        />
      );
    }
    return null;
  }

  toggleEditing() {
    this.setState({ editing: !this.state.editing });
  }

  nowEditing() {
    this.props.handleEditing(this.props.addressId);
    this.toggleEditing();
  }

  cancelEditing() {
    this.props.handleEditing(null);
    this.toggleEditing();
  }

  countryCode() {
    return (
      this.props.countryCode ||
        this.props.countryCodeDefault ||
        DEFAULT_COUNTRY_CODE
    );
  }

  componentToRender() {
    if (this.state.editing) {
      return (
        <AddressForm
          addressId={this.props.addressId}
          name={this.props.name}
          streetAddress={this.props.streetAddress}
          extendedAddress={this.props.extendedAddress}
          locality={this.props.locality}
          region={this.props.region}
          postalCode={this.props.postalCode}
          countryCode={this.countryCode()}
          phone={this.props.phone}
          formErrors={this.props.formErrors}
          cancelEditing={() => this.cancelEditing()}
          handleUpdate={() => this.handleFormUpdate()}
          displayCancelEditLink={this.props.displayCancelEditLink}
          countriesForSelect={this.props.countriesForSelect}
          formObjectName={this.props.formObjectName}
        />
      );
    }

    return (
      <AddressBox
        name={this.props.name}
        streetAddress={this.props.streetAddress}
        extendedAddress={this.props.extendedAddress}
        locality={this.props.locality}
        region={this.props.region}
        postalCode={this.props.postalCode}
        countryCode={this.props.countryCode}
        phone={this.props.phone}
        nowEditing={() => this.nowEditing()}
        addressId={this.props.addressId}
      />
    );
  }

  wrappedAddress() {
    if (this.props.selectable) {
      return (
        <label
          htmlFor={this.radioInputId()}
          className="boxed-list__item boxed-list__item--selectable"
          onClick={() => this.props.closeNewAddressForm()}
        >
          {this.componentToRender()}
        </label>
      );
    }
    return (
      <div className={classNames('boxed-list__item', { 'boxed-list__item--active' : this.state.editing })}>
        {this.componentToRender()}
      </div>
    );
  }

  render() {
    return (
      <li>
        {this.radioInput()}
        {this.wrappedAddress()}
      </li>
    );
  }
}

EditableAddress.propTypes = {
  addressId: PropTypes.string,
  name: PropTypes.string,
  streetAddress: PropTypes.string,
  extendedAddress: PropTypes.string,
  locality: PropTypes.string,
  region: PropTypes.string,
  postalCode: PropTypes.string,
  countryCode: PropTypes.string,
  phone: PropTypes.string,
  countriesForSelect: PropTypes.array.isRequired,
  handleUpdate: PropTypes.func.isRequired,
  selectable: PropTypes.bool.isRequired,
  selected: PropTypes.bool,
  editing: PropTypes.bool,
  displayCancelEditLink: PropTypes.bool,
  formObjectName: PropTypes.string,
  closeNewAddressForm: PropTypes.func.isRequired,
  handleEditing: PropTypes.func.isRequired,
  countryCodeDefault: PropTypes.string,
  formErrors: PropTypes.string,
};

EditableAddress.defaultProps = {
  closeNewAddressForm: () => null,
};

module.exports = EditableAddress;



// WEBPACK FOOTER //
// ./javascripts/components/addresses/editable_address.jsx